// Homepage showreel: one source of truth for the player (HomeShowreel.vue),
// its VideoObject JSON-LD and the video sitemap entry (nuxt.config.ts).
// Files live in the public Supabase Storage bucket `marketing-videos`, uploaded
// with docs/marketing/video/render/upload-web.mjs (see docs/marketing/video/README.md).
// The dark and light films share one timeline and soundtrack, so the player
// can swap between them mid-play without losing the playhead.

export type ShowreelMode = 'dark' | 'light'

export interface ShowreelFiles {
  /** 1080p60 AV1 in WebM: smallest, used where AV1 decodes smoothly and power-efficiently */
  av1: string
  /** 1080p60 H.264 in MP4: universal fallback */
  mp4: string
  /** 720p60 H.264 in MP4: small screens, Save-Data and slow connections */
  mp4Small: string
  /** 1920x1080 WebP poster (also the search thumbnail) */
  poster: string
}

export const SHOWREEL = {
  bucket: 'marketing-videos',
  name: 'mychar.gg in 30 seconds',
  description: 'A 30 second tour of mychar.gg: a creator\'s page starts its music when a visitor enters, pages in every layout and style, a page styled live in the editor, YouTube, Twitch and Discord connected, and the analytics creators get.',
  uploadDate: '2026-10-03',
  durationSeconds: 30,
  width: 1920,
  height: 1080,
  // MIME type with codecs, for canPlayType / MediaCapabilities checks (1080p60, 8 bit, Main profile)
  av1Type: 'video/webm; codecs="av01.0.09M.08"',
  files: {
    dark: {
      av1: 'mychar-showreel-16x9-1080p.av1.webm',
      mp4: 'mychar-showreel-16x9-1080p.mp4',
      mp4Small: 'mychar-showreel-16x9-720p.mp4',
      poster: 'mychar-showreel-16x9-poster.webp'
    },
    light: {
      av1: 'mychar-showreel-light-16x9-1080p.av1.webm',
      mp4: 'mychar-showreel-light-16x9-1080p.mp4',
      mp4Small: 'mychar-showreel-light-16x9-720p.mp4',
      poster: 'mychar-showreel-light-16x9-poster.webp'
    }
  } satisfies Record<ShowreelMode, ShowreelFiles>
} as const

/** Public URL of a showreel file, from the Supabase project URL */
export function showreelUrl(supabaseUrl: string, file: string): string {
  return `${supabaseUrl.replace(/\/+$/, '')}/storage/v1/object/public/${SHOWREEL.bucket}/${file}`
}
